export const api = {
	address: "pqcanvass.powermonitors.com",
	https: true,
	path: "/api"
}

// PQCanvass app URL for redirect after redemption
export const pqcanvass = {
	url: "https://pqcanvass.powermonitors.com"
}
